import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { scan } from "react-scan";
import { queryClient } from "./api/query-client";
import { LoadingSpinner } from "./components/custom-ui/loading.spinner";
import "./index.css";
import "./lib/instruments";
import { routes } from "./routes/routes";

async function enableMocking() {
  if (import.meta.env.VITE_FRONT_ENVIRONMENT !== "local") {
    return;
  }
  scan({
    enabled: true,
  });
  const { worker } = await import("./api/msw");
  return worker.start();
}

const router = createBrowserRouter(routes);

enableMocking()
  .catch((error) => {
    console.error("Ошибка при запуске MSW:", error);
  })
  .finally(() => {
    ReactDOM.createRoot(document.getElementById("root")!).render(
      <React.StrictMode>
        <Sentry.ErrorBoundary
          fallback={({ error, resetError }) => (
            <div className="min-h-screen flex items-center justify-center bg-background">
              <div className="text-center max-w-md mx-auto p-6">
                <h1 className="text-2xl font-bold text-destructive mb-4">Произошла ошибка</h1>
                <p className="text-muted-foreground mb-4">
                  {(error as Error).message || "Что-то пошло не так"}
                </p>
                <div className="space-y-2">
                  <button
                    onClick={resetError}
                    className="bg-primary text-primary-foreground px-4 py-2 rounded w-full"
                  >
                    Попробовать снова
                  </button>
                  <button
                    onClick={() => (window.location.href = "/")}
                    className="bg-secondary text-secondary-foreground px-4 py-2 rounded w-full"
                  >
                    На главную
                  </button>
                </div>
              </div>
            </div>
          )}
          beforeCapture={(scope, error) => {
            scope.setTag("errorBoundary", "main");
            scope.setLevel("error");
            console.log("Sentry capturing error:", error);
          }}
        >
          <QueryClientProvider client={queryClient}>
            <Suspense fallback={<LoadingSpinner />}>
              <ReactQueryDevtools initialIsOpen={false} />
              <RouterProvider router={router} />
            </Suspense>
          </QueryClientProvider>
        </Sentry.ErrorBoundary>
      </React.StrictMode>
    );
  });
